/*
 * kult-b2b-mischung-progress.js — Schrittliste, Absende-Button und mobile Leiste im Bürokaffee-Konfigurator
 * (sections/kult-b2b-mischung.liquid mit data-progress, snippets/kult-b2b-mischung-progress.liquid).
 * Läuft nur, wenn assets/kult-b2b-mischung.js das Kontaktformular angedockt hat (data-docked): Dann
 *  - füllt es die Schrittliste rechts aus den Schritt-Überschriften (1–5), aktiver Schritt nach Scroll-Position
 *    (Oberkante über 30 % der Fensterhöhe) oder Fokus, erledigt = bearbeitet oder überscrollt (1–4) bzw. Pflichtfelder gültig (5);
 *  - sendet [data-mischung-submit] das angedockte Formular über form.requestSubmit() ab (Validierung, Fehlertexte und
 *    Versand über KultB2BLead.submit macht <kult-b2b-form>, assets/kult-b2b-form.js); Sperre spiegelt aria-busy, nach
 *    Erfolg (.is-sent) verschwinden Button und Leiste;
 *  - zeigt mobil (< 960 px) die Leiste [data-mischung-bar], solange der Konfigurator im Bild ist und der Absende-Button
 *    des Formulars noch nicht;
 *  - setzt ab 960 px --kult-side-top: Ist die rechte Spalte höher als das Fenster, klebt sie mit der Unterkante, damit
 *    der Button immer sichtbar bleibt.
 */
(function () {
  'use strict';
  var DESKTOP = '(min-width: 960px)';
  var SIDE_TOP = 32;

  function reduceMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function titleOf(step) {
    var h = step.querySelector('.kult-b2b-mischung__step-title');
    if (!h) return '';
    var clone = h.cloneNode(true);
    var num = clone.querySelector('.kult-b2b-mischung__step-num');
    if (num) num.remove();
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function setup(app) {
    if (app.__kultProgress || !app.hasAttribute('data-docked')) return;
    var form = app.querySelector('[data-mischung-contact] form');
    var nav = app.querySelector('[data-mischung-progress]');
    var list = app.querySelector('[data-mischung-progress-list]');
    if (!form || !nav || !list) return;
    app.__kultProgress = true;

    var steps = Array.prototype.slice.call(app.querySelectorAll('.kult-b2b-mischung__controls > .kult-b2b-mischung__step, [data-mischung-contact]'));
    var last = steps.length - 1;
    var side = app.querySelector('[data-mischung-side]');
    var bar = app.querySelector('[data-mischung-bar]');
    var barNum = app.querySelector('[data-mischung-bar-num]');
    var barTitle = app.querySelector('[data-mischung-bar-title]');
    var buttons = Array.prototype.slice.call(app.querySelectorAll('[data-mischung-submit]'));
    var ownSubmit = form.querySelector('[data-form-submit]');
    var tpl = app.querySelector('[data-mischung-progress-check]');
    var checkSvg = tpl ? tpl.innerHTML : '';
    var titles = steps.map(titleOf);
    var touched = steps.map(function () { return false; });
    var active = 0;
    var items = [];

    titles.forEach(function (title, i) {
      var li = document.createElement('li');
      li.className = 'kult-b2b-mischung__progress-item';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kult-b2b-mischung__progress-btn';
      btn.innerHTML = '<span class="kult-b2b-mischung__progress-num kult-b2b-num" aria-hidden="true"><span class="kult-b2b-mischung__progress-digit">' + (i + 1) + '</span><span class="kult-b2b-mischung__progress-check">' + checkSvg + '</span></span>' +
        '<span class="kult-b2b-mischung__progress-label"></span><span class="visually-hidden" data-state></span>';
      btn.querySelector('.kult-b2b-mischung__progress-label').textContent = title;
      btn.addEventListener('click', function () { goTo(i); });
      li.appendChild(btn);
      list.appendChild(li);
      items.push(btn);
    });
    nav.hidden = false;

    function goTo(i) {
      var step = steps[i];
      if (!step) return;
      step.scrollIntoView({ block: 'start', behavior: reduceMotion() ? 'auto' : 'smooth' });
      var h = step.querySelector('.kult-b2b-mischung__step-title');
      if (h) window.setTimeout(function () { h.focus({ preventScroll: true }); }, reduceMotion() ? 0 : 450);
      setActive(i);
    }

    function contactDone() {
      var req = form.querySelectorAll('input[required], select[required], textarea[required]');
      for (var k = 0; k < req.length; k++) { if (!req[k].validity.valid) return false; }
      return req.length > 0;
    }
    function isDone(i) {
      if (form.classList.contains('is-sent')) return true;
      if (i === last) return contactDone();
      return touched[i] || active > i;
    }
    function render() {
      items.forEach(function (btn, i) {
        var done = isDone(i);
        btn.classList.toggle('is-active', i === active);
        btn.classList.toggle('is-done', done);
        if (i === active) btn.setAttribute('aria-current', 'step'); else btn.removeAttribute('aria-current');
        btn.querySelector('[data-state]').textContent = done ? ', erledigt' : '';
      });
      /* Weg „Warenkorb“ (data-path="cart", 11.10.2026): Schritt 5 ist ausgeblendet, die Leiste zählt nur sichtbare Schritte */
      var shown = steps.filter(function (st) { return st.offsetParent !== null; });
      var pos = shown.indexOf(steps[active]);
      if (barNum) barNum.textContent = (pos > -1 ? pos + 1 : active + 1) + '/' + (shown.length || steps.length);
      if (barTitle) barTitle.textContent = titles[active] || '';
    }
    function setActive(i) { if (i !== active && i >= 0) { active = i; render(); } }

    /* Aktiver Schritt: der letzte sichtbare Schritt, dessen Oberkante über 30 % der Fensterhöhe liegt (Scroll-Position,
       gedrosselt per rAF; ab 990 px scrollt .page-wrapper statt window, darum Scroll-Ereignisse in der Capture-Phase) */
    var ticking = false;
    function fromScroll() {
      ticking = false;
      var line = window.innerHeight * 0.3;
      var idx = 0;
      steps.forEach(function (s, i) {
        if (s.offsetParent !== null && s.getBoundingClientRect().top <= line) idx = i;
      });
      setActive(idx);
    }
    document.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(fromScroll); }
    }, { capture: true, passive: true });
    steps.forEach(function (s, i) {
      s.addEventListener('focusin', function () { setActive(i); });
      var mark = function () { touched[i] = true; render(); };
      s.addEventListener('change', mark);
      s.addEventListener('input', mark);
      s.addEventListener('click', function (e) { if (e.target.closest('button, input, label')) mark(); });
    });

    /* Absenden über den Button rechts bzw. die Leiste */
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        if (form.getAttribute('aria-busy') === 'true') return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else if (ownSubmit) ownSubmit.click();
      });
    });
    function syncForm() {
      var busy = form.getAttribute('aria-busy') === 'true';
      var sent = form.classList.contains('is-sent');
      buttons.forEach(function (b) {
        b.disabled = busy;
        if (busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
        b.hidden = sent;
      });
      app.toggleAttribute('data-sent', sent);
      render();
      updateBar();
    }
    new MutationObserver(syncForm).observe(form, { attributes: true, attributeFilter: ['aria-busy', 'class'] });

    /* Mobile Leiste */
    var appVisible = false;
    var ownVisible = false;
    var mq = window.matchMedia(DESKTOP);
    function updateBar() {
      if (!bar) return;
      var coffee = app.getAttribute('data-coffee');
      bar.hidden = mq.matches || !appVisible || ownVisible || form.classList.contains('is-sent') || !coffee || coffee === 'none';
    }
    if ('IntersectionObserver' in window && bar) {
      new IntersectionObserver(function (e) { appVisible = e[0].isIntersecting; updateBar(); }).observe(app);
      if (ownSubmit) new IntersectionObserver(function (e) { ownVisible = e[0].isIntersecting; updateBar(); }).observe(ownSubmit);
    }
    new MutationObserver(function () { updateBar(); render(); }).observe(app, { attributes: true, attributeFilter: ['data-coffee', 'data-path'] });

    /* Richtwert in der Leiste (Audit 10.10.2026): spiegelt [data-sum="summe"] der Zusammenfassung, Label „einmalig“ bzw. „im Monat“ */
    var barSum = app.querySelector('[data-mischung-bar-sum]');
    var sumEl = app.querySelector('[data-sum="summe"]');
    var sumRow = app.querySelector('[data-sum-row="summe"]');
    var sumLabel = app.querySelector('[data-sum-label="summe"]');
    /* Kaufweg (11.10.2026): statt Richtwert der genaue Netto-Betrag aus der Kauf-Zusammenfassung, ohne „≈“ */
    var buyNet = app.querySelector('[data-buy="net"]');
    function syncSum() {
      if (!barSum || !sumEl) return;
      if (buyNet && app.getAttribute('data-path') === 'cart' && app.getAttribute('data-buy') === 'ready') {
        var net = (buyNet.textContent || '').trim();
        barSum.innerHTML = net ? '<strong class="kult-b2b-num">' + net.replace(/</g, '') + '</strong> netto zzgl. MwSt.' : '';
        barSum.hidden = !net;
        return;
      }
      var val = (sumEl.textContent || '').trim();
      var show = !!val && !(sumRow && sumRow.hidden);
      var once = sumLabel && /einmalig/i.test(sumLabel.textContent || '');
      barSum.innerHTML = show ? '<strong class="kult-b2b-num">≈ ' + val.replace(/</g, '') + '</strong> netto' + (once ? ', einmalig' : ' im Monat') : '';
      barSum.hidden = !show;
    }
    if (barSum && sumEl) {
      new MutationObserver(syncSum).observe(sumEl, { childList: true, characterData: true, subtree: true });
      if (sumRow) new MutationObserver(syncSum).observe(sumRow, { attributes: true, attributeFilter: ['hidden'] });
      if (sumLabel) new MutationObserver(syncSum).observe(sumLabel, { childList: true, characterData: true, subtree: true });
      if (buyNet) {
        new MutationObserver(syncSum).observe(buyNet, { childList: true, characterData: true, subtree: true });
        new MutationObserver(syncSum).observe(app, { attributes: true, attributeFilter: ['data-path', 'data-buy'] });
      }
      syncSum();
    }

    /* Rechte Spalte: klebt oben, bei Überlänge mit der Unterkante */
    function placeSide() {
      if (!side) return;
      if (!mq.matches) { side.style.removeProperty('--kult-side-top'); return; }
      var room = window.innerHeight - side.offsetHeight - 16;
      side.style.setProperty('--kult-side-top', Math.min(SIDE_TOP, room) + 'px');
    }
    if ('ResizeObserver' in window && side) new ResizeObserver(placeSide).observe(side);
    window.addEventListener('resize', placeSide);
    if (mq.addEventListener) mq.addEventListener('change', function () { placeSide(); updateBar(); });

    form.addEventListener('input', render);
    form.addEventListener('change', render);
    render();
    fromScroll();
    placeSide();
    syncForm();
  }

  function init() {
    var apps = document.querySelectorAll('kult-b2b-mischung[data-progress]');
    Array.prototype.forEach.call(apps, function (app) {
      if (app.hasAttribute('data-docked')) { setup(app); return; }
      /* dockForm läuft im connectedCallback des Konfigurators; bis dahin auf data-docked warten */
      var mo = new MutationObserver(function () { if (app.hasAttribute('data-docked')) { mo.disconnect(); setup(app); } });
      mo.observe(app, { attributes: true, attributeFilter: ['data-docked'] });
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('kult-b2b-mischung').then(init);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
